import React from 'react';
import css from './ErrorLabel.module.scss';


/**
 * @class
 *
 * A presentational component for error labels.
 *
 * Common use case is form validation error labels.
 * Doesn't accept any props, but accepts children elements (i.e. pass markup/text between the opening and closing tags).
 *
 * @example
 *  // If we want to use this component in conjunction with Formik's built-in `ErrorMessage` component, we simply pass the component to the `component` property:
 *  <ErrorMessage name="foo" component={ErrorLabel} />
 *
 *  // If we want to use the component stand-alone:
 *  <ErrorLabel>My error message... Lorem ipsum dolor sit amet...</ErrorLabel>
 */
const ErrorLabel = (props) => {
    return <div className={css.ErrorLabel}>{props.children}</div>;
};

export default ErrorLabel;

